import React from 'react';

function Home() {
  return (
    <div>
      <div className="home_page">
        <h1 className="home_heading">Welcome to Math Magicians!</h1>
        <p className="home_paragraph">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus metus
          augue, mattis vel iaculis non, fringilla vitae orci. Cras eu lectus non
          tellus ullamcorper consectetur id ac odio. Phasellus convallis a lacus
          eget semper. Interdum et malesuada fames ac ante ipsum primis in faucibus.
          Aenean vestibulum nibh ac dolor malesuada varius. Morbi nec posuere magna.
          Morbi bibendum eros vel ligula tempus, sit amet curus libero aliquam. Duis
          vestibulum eu quam vel lacinia. Pellentesque vel mollis nisl, in feugiat risus.
          Aliquam erat volutpat. Suspendisse id ullamcorper lectus, eget consequat elit.
        </p>
      </div>
    </div>
  );
}

export default Home;
